import {normalizeFastGlobalCitationBbox} from './fastGlobalStream';

const statuses = new Set(['resolved', 'page_only', 'document_only', 'unresolved']);
export const canonicalCitations = comment => {
    let metadata = comment?.metadata_json || comment?.metadataJson || {};
    if (typeof metadata === 'string') {
        try {metadata = JSON.parse(metadata);} catch (_) {metadata = {};}
    }
    const values = comment?.citations || metadata.citations || metadata.fast_global_card_v1?.citations || [];
    return Array.isArray(values) ? values.filter(part => statuses.has(part?.resolution_status)) : [];
};

export const citationCommentRef = comment => canonicalCitations(comment).length ? comment.id : null;

export const citationDocumentOptions = comment => [...new Map(canonicalCitations(comment)
    .filter(part => part.document_version_id && part.file_id && part.resolution_status !== 'unresolved')
    .map(part => [part.document_version_id, {id: part.document_version_id, label: part.document_name || part.document_title || null}])).values()]
    .map((option, index) => ({...option, label: option.label || `Document ${index + 1}`}));

const located = part => part.resolution_status === 'resolved' && part.document_version_id && part.file_id
    && Number.isInteger(part.page) && part.page > 0 && normalizeFastGlobalCitationBbox(part.bbox);

export const citationHighlightBlocks = (comments, documentVersionId) => (comments || []).flatMap(comment => (
    canonicalCitations(comment).filter(part => located(part) && part.document_version_id === documentVersionId)
        .map(part => ({
            ...part, ref: comment.id, comment_id: comment.id, text: part.excerpt || '',
            bbox: normalizeFastGlobalCitationBbox(part.bbox), kind: 'resolved_source_citation',
            blockId: part.block_id || part.evidence_ids?.[0] || part.citation_id,
        }))
));

export const buildCommentCitationNavigation = (comment, documentVersionId = null) => {
    const citations = canonicalCitations(comment);
    if (!citations.length || !comment.id) return null;
    const known = citations.filter(part => part.document_version_id && part.file_id
        && (!documentVersionId || part.document_version_id === documentVersionId));
    const anchor = known.find(located)
        || known.find(part => part.resolution_status === 'page_only' && Number.isInteger(part.page) && part.page > 0)
        || known.find(part => part.resolution_status === 'document_only');
    if (!anchor) return {source_kind: 'citation', comment_id: comment.id, unavailable: true};
    const parts = citations.filter(part => part.document_version_id === anchor.document_version_id && part.file_id === anchor.file_id);
    const highlights = parts.filter(located);
    return {
        source_kind: 'citation', comment_id: comment.id, ref: comment.id,
        version: {document_version_id: anchor.document_version_id, title: 'Source contractuelle'},
        evidence: {
            ...anchor, role: 'source', source_kind: 'citation', comment_id: comment.id,
            page: anchor.resolution_status === 'document_only' ? null : anchor.page,
            bbox: located(anchor) ? anchor.bbox : null,
            highlights,
            citation_partial: parts.some(part => part.resolution_status !== 'resolved'),
        },
    };
};
